import React, { useState, useEffect } from 'react';
import { TOKEN_META } from '../data';

// CoinGecko coin image URLs (most reliable and faithful icons)
const ICON_URLS = {
  USDC:     "https://assets.coingecko.com/coins/images/6319/small/usdc.png",
  "USDC.e": "https://assets.coingecko.com/coins/images/6319/small/usdc.png",
  USDbC:    "https://assets.coingecko.com/coins/images/6319/small/usdc.png",
  USDT:     "https://assets.coingecko.com/coins/images/325/small/Tether.png",
  DAI:      "https://assets.coingecko.com/coins/images/9956/small/Badge_Dai.png",
  ETH:      "https://assets.coingecko.com/coins/images/279/small/ethereum.png",
  WETH:     "https://assets.coingecko.com/coins/images/2518/small/weth.png",
  WBTC:     "https://assets.coingecko.com/coins/images/7598/small/wrapped_bitcoin_wbtc.png",
  FRAX:     "https://assets.coingecko.com/coins/images/13422/small/FRAX_icon.png",
  ARB:      "https://assets.coingecko.com/coins/images/16547/small/arb.jpg",
  crvUSD:   "https://assets.coingecko.com/coins/images/30118/small/crvusd.jpeg",
  CRVUSD:   "https://assets.coingecko.com/coins/images/30118/small/crvusd.jpeg",
  GHO:      "https://assets.coingecko.com/coins/images/30663/small/gho-token-logo.png",
  LUSD:     "https://assets.coingecko.com/coins/images/14666/small/Group_3.png",
  sUSD:     "https://assets.coingecko.com/coins/images/5013/small/sUSD.png",
  SUSD:     "https://assets.coingecko.com/coins/images/5013/small/sUSD.png",
  PYUSD:    "https://assets.coingecko.com/coins/images/31212/small/PYUSD_Logo_%282%29.png",
  USDS:     "https://assets.coingecko.com/coins/images/39926/small/usds.webp",
  TUSD:     "https://assets.coingecko.com/coins/images/3449/small/tusd.png",
  GUSD:     "https://assets.coingecko.com/coins/images/5992/small/gemini-dollar-gusd.png",
  MIM:      "https://assets.coingecko.com/coins/images/16786/small/mimlogopng.png",
  DOLA:     "https://assets.coingecko.com/coins/images/14287/small/dola.png",
  "USD+":   "https://assets.coingecko.com/coins/images/25757/small/USD__logo.png",
  USDD:     "https://assets.coingecko.com/coins/images/25380/small/USDD.jpg",
  USDP:     "https://assets.coingecko.com/coins/images/6013/small/Pax_Dollar.png",
  alUSD:    "https://assets.coingecko.com/coins/images/14114/small/Alchemix_USD.png",
  eUSD:     "https://assets.coingecko.com/coins/images/28445/small/0xa0d69e286b938e21cbf7e51d71f6a4c8918f482f.png",
  RAI:      "https://assets.coingecko.com/coins/images/14004/small/RAI-logo-coin.png",
  OP:       "https://assets.coingecko.com/coins/images/25244/small/Optimism.png",
  MATIC:    "https://assets.coingecko.com/coins/images/4713/small/polygon.png",
  POL:      "https://assets.coingecko.com/coins/images/4713/small/polygon.png",
  AAVE:     "https://assets.coingecko.com/coins/images/12645/small/aave-token-round.png",
  CRV:      "https://assets.coingecko.com/coins/images/12124/small/Curve.png",
  BAL:      "https://assets.coingecko.com/coins/images/11683/small/Balancer.png",
  LINK:     "https://assets.coingecko.com/coins/images/877/small/chainlink-new-logo.png",
  UNI:      "https://assets.coingecko.com/coins/images/12504/small/uni.jpg",
  stETH:    "https://assets.coingecko.com/coins/images/13442/small/steth_logo.png",
  STETH:    "https://assets.coingecko.com/coins/images/13442/small/steth_logo.png",
  wstETH:   "https://assets.coingecko.com/coins/images/18834/small/wstETH.png",
  WSTETH:   "https://assets.coingecko.com/coins/images/18834/small/wstETH.png",
  rETH:     "https://assets.coingecko.com/coins/images/20764/small/reth.png",
  RETH:     "https://assets.coingecko.com/coins/images/20764/small/reth.png",
  cbETH:    "https://assets.coingecko.com/coins/images/27008/small/cbeth.png",
  CBETH:    "https://assets.coingecko.com/coins/images/27008/small/cbeth.png",
  // Additional common tokens
  COMP:     "https://assets.coingecko.com/coins/images/10775/small/COMP.png",
  SNX:      "https://assets.coingecko.com/coins/images/3406/small/SNX.png",
  MKR:      "https://assets.coingecko.com/coins/images/1364/small/Mark_Maker.png",
  LDO:      "https://assets.coingecko.com/coins/images/13573/small/Lido_DAO.png",
  RPL:      "https://assets.coingecko.com/coins/images/2090/small/rocket_pool_%28RPL%29.png",
  SFRXETH:  "https://assets.coingecko.com/coins/images/28462/small/sfrxETH.png",
  sfrxETH:  "https://assets.coingecko.com/coins/images/28462/small/sfrxETH.png",
  frxETH:   "https://assets.coingecko.com/coins/images/28284/small/frxETH_icon.png",
  FRXETH:   "https://assets.coingecko.com/coins/images/28284/small/frxETH_icon.png",
  CBBTC:    "https://assets.coingecko.com/coins/images/40143/small/cbbtc.webp",
  cbBTC:    "https://assets.coingecko.com/coins/images/40143/small/cbbtc.webp",
  // High-frequency tokens from DeFi Llama
  OUSD:     "https://assets.coingecko.com/coins/images/14103/small/OUSD.png",
  WMATIC:   "https://assets.coingecko.com/coins/images/14073/small/matic.png",
  SCRVUSD:  "https://assets.coingecko.com/coins/images/30118/small/crvusd.jpeg",
  TBTC:     "https://assets.coingecko.com/coins/images/11224/small/0x18084fba666a33d37592fa2633fd49a74dd93a88.png",
  SUSDE:    "https://assets.coingecko.com/coins/images/33669/small/sUSDe.png",
  sUSDe:    "https://assets.coingecko.com/coins/images/33669/small/sUSDe.png",
  USDE:     "https://assets.coingecko.com/coins/images/33613/small/usde.png",
  USDe:     "https://assets.coingecko.com/coins/images/33613/small/usde.png",
  FRXUSD:   "https://assets.coingecko.com/coins/images/13422/small/FRAX_icon.png",
  FXUSD:    "https://assets.coingecko.com/coins/images/36017/small/fxUSD.png",
  CVX:      "https://assets.coingecko.com/coins/images/15585/small/convex.png",
  OETH:     "https://assets.coingecko.com/coins/images/29733/small/oeth.png",
  SFRXUSD:  "https://assets.coingecko.com/coins/images/13422/small/FRAX_icon.png",
  XAUT:     "https://assets.coingecko.com/coins/images/11677/small/tether-gold.png",
  PAXG:     "https://assets.coingecko.com/coins/images/9519/small/paxg.PNG",
  TEL:      "https://assets.coingecko.com/coins/images/1899/small/tel.png",
  PENDLE:   "https://assets.coingecko.com/coins/images/15069/small/Pendle_Logo_Normal-03.png",
  OHM:      "https://assets.coingecko.com/coins/images/14483/small/token_OHM_%281%29.png",
  WEETH:    "https://assets.coingecko.com/coins/images/33033/small/weETH.png",
  weETH:    "https://assets.coingecko.com/coins/images/33033/small/weETH.png",
  PUFETH:   "https://assets.coingecko.com/coins/images/34618/small/pufETH.png",
  pufETH:   "https://assets.coingecko.com/coins/images/34618/small/pufETH.png",
  BOLD:     "https://assets.coingecko.com/coins/images/38539/small/bold.png",
  GNO:      "https://assets.coingecko.com/coins/images/662/small/logo_square_simple_300px.png",
  ENS:      "https://assets.coingecko.com/coins/images/19785/small/acatxTm8_400x400.jpg",
  EIGEN:    "https://assets.coingecko.com/coins/images/37441/small/eigen.png",
  ENA:      "https://assets.coingecko.com/coins/images/36530/small/ethena.png",
  ONDO:     "https://assets.coingecko.com/coins/images/26580/small/ONDO.png",
  FXS:      "https://assets.coingecko.com/coins/images/13423/small/Frax_Shares_icon.png",
  RSR:      "https://assets.coingecko.com/coins/images/8365/small/rsr.png",
  LBTC:     "https://assets.coingecko.com/coins/images/38595/small/lbtc.png",
  SKY:      "https://assets.coingecko.com/coins/images/39925/small/sky.png",
  SOL:      "https://assets.coingecko.com/coins/images/4128/small/solana.png",
  PEPE:     "https://assets.coingecko.com/coins/images/29850/small/pepe-token.jpeg",
  SHIB:     "https://assets.coingecko.com/coins/images/11939/small/shiba.png",
  "1INCH":  "https://assets.coingecko.com/coins/images/13469/small/1inch-token.png",
  RNDR:     "https://assets.coingecko.com/coins/images/11636/small/rndr.png",
  INJ:      "https://assets.coingecko.com/coins/images/12882/small/Secondary_Symbol.png",
  FET:      "https://assets.coingecko.com/coins/images/5681/small/Fetch.jpg",
  GRT:      "https://assets.coingecko.com/coins/images/13397/small/Graph_Token.png",
  BONK:     "https://assets.coingecko.com/coins/images/28600/small/bonk.jpg",
  WLD:      "https://assets.coingecko.com/coins/images/31069/small/worldcoin.jpeg",
  RDNT:     "https://assets.coingecko.com/coins/images/26536/small/Radiant-Logo-200x200.png",
  GMX:      "https://assets.coingecko.com/coins/images/18323/small/arbit.png",
  STG:      "https://assets.coingecko.com/coins/images/24413/small/STG_LOGO.png",
  MORPHO:   "https://assets.coingecko.com/coins/images/38559/small/morpho.jpeg",
  COW:      "https://assets.coingecko.com/coins/images/14802/small/cow.png",
  EURC:     "https://assets.coingecko.com/coins/images/26045/small/euro-coin.png",
  EURA:     "https://assets.coingecko.com/coins/images/19479/small/agEUR.png",
  SDAI:     "https://assets.coingecko.com/coins/images/32610/small/sdai.png",
  sDAI:     "https://assets.coingecko.com/coins/images/32610/small/sdai.png",
  SUSDS:    "https://assets.coingecko.com/coins/images/39926/small/usds.webp",
  sUSDS:    "https://assets.coingecko.com/coins/images/39926/small/usds.webp",
  MUSD:     "https://assets.coingecko.com/coins/images/4056/small/mStable.png",
  ALUSD:    "https://assets.coingecko.com/coins/images/14114/small/Alchemix_USD.png",
  ALETH:    "https://assets.coingecko.com/coins/images/14666/small/Group_3.png",
  SDOLA:    "https://assets.coingecko.com/coins/images/14287/small/dola.png",
  RLUSD:    "https://assets.coingecko.com/coins/images/42073/small/rlusd.png",
  ETHFI:    "https://assets.coingecko.com/coins/images/35958/small/etherfi.jpeg",
  SAFE:     "https://assets.coingecko.com/coins/images/27032/small/Artboard_1.png",
  INV:      "https://assets.coingecko.com/coins/images/14205/small/inverse_finance.jpg",
  DBR:      "https://assets.coingecko.com/coins/images/29175/small/dbr.png",
  "ETH+":   "https://assets.coingecko.com/coins/images/279/small/ethereum.png",
  USDBC:    "https://assets.coingecko.com/coins/images/6319/small/usdc.png",
  STMATIC:  "https://assets.coingecko.com/coins/images/24185/small/stMATIC.png",
  stMATIC:  "https://assets.coingecko.com/coins/images/24185/small/stMATIC.png",
  MAI:      "https://assets.coingecko.com/coins/images/15264/small/mimatic-red.png",
  EURS:     "https://assets.coingecko.com/coins/images/5164/small/EURS_300x300.png",
  VIRTUAL:  "https://assets.coingecko.com/coins/images/36035/small/virtual.jpeg",
  ZRO:      "https://assets.coingecko.com/coins/images/28206/small/ftxG9_TJ_400x400.jpeg",
  // New manual mappings for top DeFi Llama tokens
  WBNB:     "https://coin-images.coingecko.com/coins/images/12591/thumb/binance-coin-logo.png",
  BNB:      "https://assets.coingecko.com/coins/images/825/small/bnb-icon2_2x.png",
  "USDC.E": "https://assets.coingecko.com/coins/images/6319/small/usdc.png",
  WAVAX:    "https://coin-images.coingecko.com/coins/images/15075/thumb/wrapped-avax.png",
  AVAX:     "https://assets.coingecko.com/coins/images/12559/small/Avalanche_Circle_RedWhite_Trans.png",
  CELO:     "https://coin-images.coingecko.com/coins/images/11090/thumb/InjXBNx9_400x400.jpg",
  CUSD:     "https://coin-images.coingecko.com/coins/images/68272/thumb/cUSD_ab_500%C3%97500.png",
  WTAO:     "https://coin-images.coingecko.com/coins/images/29087/thumb/wtao.png",
  TAO:      "https://assets.coingecko.com/coins/images/28452/small/ARUsPeNQ_400x400.jpeg",
  OLAS:     "https://coin-images.coingecko.com/coins/images/31099/thumb/OLAS-token.png",
  "3CRV":   "https://coin-images.coingecko.com/coins/images/12972/thumb/3pool_128.png",
  AM3CRV:   "https://coin-images.coingecko.com/coins/images/26740/thumb/W1sQNVWo_400x400.jpeg",
  DUSD:     "https://coin-images.coingecko.com/coins/images/55984/thumb/output-onlinepngtools.png",
  USD3:     "https://coin-images.coingecko.com/coins/images/38073/thumb/usd3%28200_x_200_px%29.png",
  "BTC.B":  "https://assets.coingecko.com/coins/images/7598/small/wrapped_bitcoin_wbtc.png",
  CEUR:     "https://assets.coingecko.com/coins/images/14020/small/cEUR.png",
  WFRAX:    "https://assets.coingecko.com/coins/images/13422/small/FRAX_icon.png",
  FDUSD:    "https://assets.coingecko.com/coins/images/31079/small/FDUSD_icon_black.png",
  CAKE:     "https://assets.coingecko.com/coins/images/12632/small/pancakeswap-cake-logo_%281%29.png",
  BTCB:     "https://assets.coingecko.com/coins/images/14108/small/Binance-bitcoin.png",
  WSOL:     "https://assets.coingecko.com/coins/images/4128/small/solana.png",
  RAY:      "https://assets.coingecko.com/coins/images/13928/small/PSigc4ie_400x400.jpg",
  JUP:      "https://assets.coingecko.com/coins/images/34188/small/jup.png",
  MSOL:     "https://assets.coingecko.com/coins/images/17752/small/mSOL.png",
  mSOL:     "https://assets.coingecko.com/coins/images/17752/small/mSOL.png",
  JITOSOL:  "https://assets.coingecko.com/coins/images/28468/small/JitoSOL.png",
  jitoSOL:  "https://assets.coingecko.com/coins/images/28468/small/JitoSOL.png",
  BSOL:     "https://assets.coingecko.com/coins/images/26636/small/bSOL.png",
  bSOL:     "https://assets.coingecko.com/coins/images/26636/small/bSOL.png",
  FUSDT:    "https://assets.coingecko.com/coins/images/325/small/Tether.png",
  FRAXBP:   "https://assets.coingecko.com/coins/images/13422/small/FRAX_icon.png",
  BTC:      "https://assets.coingecko.com/coins/images/1/small/bitcoin.png",
  EZETH:    "https://assets.coingecko.com/coins/images/34753/small/ezeth.png",
  ezETH:    "https://assets.coingecko.com/coins/images/34753/small/ezeth.png",
  RSETH:    "https://assets.coingecko.com/coins/images/34490/small/rseth.png",
  rsETH:    "https://assets.coingecko.com/coins/images/34490/small/rseth.png",
  METH:     "https://assets.coingecko.com/coins/images/33345/small/meth.png",
  mETH:     "https://assets.coingecko.com/coins/images/33345/small/meth.png",
  SWETH:    "https://assets.coingecko.com/coins/images/30326/small/sweth.png",
  swETH:    "https://assets.coingecko.com/coins/images/30326/small/sweth.png",
  ANKR:     "https://assets.coingecko.com/coins/images/4324/small/U85xTl2.png",
  ANKRR:    "https://assets.coingecko.com/coins/images/4324/small/U85xTl2.png",
  ankrETH:  "https://assets.coingecko.com/coins/images/23620/small/ankrETH.png",
  ANKRETH:  "https://assets.coingecko.com/coins/images/23620/small/ankrETH.png",
  YFI:      "https://assets.coingecko.com/coins/images/11849/small/yearn.jpg",
  SUSHI:    "https://assets.coingecko.com/coins/images/12271/small/512x512_Logo_no_chop.png",
  SPELL:    "https://assets.coingecko.com/coins/images/15861/small/abracadabra-3.png",
  FLX:      "https://assets.coingecko.com/coins/images/14876/small/FLX.png",
  GEAR:     "https://assets.coingecko.com/coins/images/29199/small/GEAR.png",
  ALCX:     "https://assets.coingecko.com/coins/images/14113/small/Alchemix.png",
  BADGER:   "https://assets.coingecko.com/coins/images/13287/small/badger_dao_logo.jpg",
  AURA:     "https://assets.coingecko.com/coins/images/25942/small/aura.png",
  WDOGE:    "https://assets.coingecko.com/coins/images/5/small/dogecoin.png",
  DOGE:     "https://assets.coingecko.com/coins/images/5/small/dogecoin.png",
  STETH2:   "https://assets.coingecko.com/coins/images/13442/small/steth_logo.png",
  AGEUR:    "https://assets.coingecko.com/coins/images/19479/small/agEUR.png",
  USDA:     "https://assets.coingecko.com/coins/images/34510/small/usda.png",
  USDR:     "https://assets.coingecko.com/coins/images/28552/small/USDR.png",
  EURT:     "https://assets.coingecko.com/coins/images/17385/small/Tether_full_logo_dm.png",
  MKUSD:    "https://assets.coingecko.com/coins/images/31519/small/mkusd.png",
  GYD:      "https://assets.coingecko.com/coins/images/30367/small/GYD.png",
  OSETH:    "https://assets.coingecko.com/coins/images/30570/small/osETH.png",
  osETH:    "https://assets.coingecko.com/coins/images/30570/small/osETH.png",
  ETHX:     "https://assets.coingecko.com/coins/images/30870/small/ethx.png",
  ETHx:     "https://assets.coingecko.com/coins/images/30870/small/ethx.png",
  R:        "https://assets.coingecko.com/coins/images/29619/small/R_logo.png",
  DINERO:   "https://assets.coingecko.com/coins/images/29618/small/dinero.png",
  WUSDM:    "https://assets.coingecko.com/coins/images/31719/small/wusdm.png",
  USDM:     "https://assets.coingecko.com/coins/images/31719/small/wusdm.png",
};

// Fallback: try Trust Wallet by Ethereum contract address
const TRUST_WALLET_FALLBACKS = {
  USDC:   "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
  USDT:   "0xdAC17F958D2ee523a2206206994597C13D831ec7",
  DAI:    "0x6B175474E89094C44Da98b954EedeAC495271d0F",
  WETH:   "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
  WBTC:   "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
  FRAX:   "0x853d955aCEf822Db058eb8505911ED77F175b99e",
  LINK:   "0x514910771AF9Ca656af840dff83E8264EcF986CA",
  UNI:    "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984",
  AAVE:   "0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9",
  CRV:    "0xD533a949740bb3306d119CC777fa900bA034cd52",
};

function getTrustWalletUrl(symbol) {
  const addr = TRUST_WALLET_FALLBACKS[symbol];
  if (!addr) return null;
  return `https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/${addr}/logo.png`;
}

// ---------------------------------------------------------------------------
// Dynamic icon resolution with caching
// ---------------------------------------------------------------------------

// Module-level cache: symbol -> URL string | "no-icon"
const iconCache = new Map();

// Rate-limiter for CoinGecko API: max 1 request per 500ms
let lastCoinGeckoCall = 0;
const COINGECKO_MIN_INTERVAL = 500;

// In-flight fetch promises keyed by symbol (avoids duplicate requests)
const pendingFetches = new Map();

/**
 * Attempt to resolve an icon URL for a token not in ICON_URLS.
 * Tries CoinGecko search API, then Etherscan pattern.
 * Returns a URL string on success, or "no-icon" on failure.
 */
async function resolveIconUrl(symbol) {
  // 1) Try CoinGecko search API (with rate limiting)
  try {
    const now = Date.now();
    const waitMs = Math.max(0, COINGECKO_MIN_INTERVAL - (now - lastCoinGeckoCall));
    if (waitMs > 0) {
      await new Promise((r) => setTimeout(r, waitMs));
    }
    lastCoinGeckoCall = Date.now();

    const query = symbol.replace(/[^a-zA-Z0-9]/g, "");
    const res = await fetch(
      `https://api.coingecko.com/api/v3/search?query=${encodeURIComponent(query)}`
    );
    if (res.ok) {
      const data = await res.json();
      const coins = data.coins || [];
      // Find a coin whose symbol matches (case-insensitive)
      const upperSym = symbol.toUpperCase().replace(/[^A-Z0-9]/g, "");
      const match =
        coins.find((c) => c.symbol?.toUpperCase() === upperSym) || coins[0];
      if (match) {
        // Prefer "small" over "thumb" for better quality
        const thumb = match.thumb || "";
        const url = thumb.replace("/thumb/", "/small/") || thumb;
        if (url && !url.includes("missing")) {
          return url;
        }
      }
    }
  } catch (_) {
    // CoinGecko unavailable - continue to next fallback
  }

  // 2) Try Etherscan token icon pattern
  try {
    const etherscanUrl = `https://etherscan.io/token/images/${symbol.toLowerCase()}_32.png`;
    await fetch(etherscanUrl, { method: "HEAD", mode: "no-cors" });
    // no-cors means we can't check status, but we return the URL optimistically
    // and let <img onError> handle actual failures
    return etherscanUrl;
  } catch (_) {
    // Etherscan unreachable
  }

  return "no-icon";
}

/**
 * Kick off a fetch for a symbol (if not already cached or in-flight).
 * Returns a Promise that resolves when the icon URL is known.
 */
function fetchIconForSymbol(symbol) {
  if (iconCache.has(symbol)) return Promise.resolve(iconCache.get(symbol));

  if (pendingFetches.has(symbol)) return pendingFetches.get(symbol);

  const promise = resolveIconUrl(symbol).then((url) => {
    iconCache.set(symbol, url);
    pendingFetches.delete(symbol);
    return url;
  });
  pendingFetches.set(symbol, promise);
  return promise;
}

// ---------------------------------------------------------------------------
// Custom hook: useResolvedIcon
// ---------------------------------------------------------------------------

function useResolvedIcon(symbol) {
  const [dynamicUrl, setDynamicUrl] = useState(() => {
    // Check cache synchronously on mount
    const cached = iconCache.get(symbol);
    if (cached && cached !== "no-icon") return cached;
    return null;
  });

  useEffect(() => {
    // Skip if we already have a static mapping
    const staticUrl = ICON_URLS[symbol] || ICON_URLS[symbol?.toUpperCase()];
    if (staticUrl) return;

    let cancelled = false;

    fetchIconForSymbol(symbol).then((url) => {
      if (!cancelled && url && url !== "no-icon") {
        setDynamicUrl(url);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [symbol]);

  return dynamicUrl;
}

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

export default function TokenIcon({ symbol, size = 26 }) {
  const [imgError, setImgError] = useState(false);
  const [fallbackError, setFallbackError] = useState(false);
  const [dynamicError, setDynamicError] = useState(false);
  const meta = TOKEN_META[symbol] || { color: "#999", bg: "#F0F0F0", letter: symbol?.[0] || "?" };

  // Static icon URL from manual mappings
  const url = ICON_URLS[symbol] || ICON_URLS[symbol?.toUpperCase()];
  const trustUrl = getTrustWalletUrl(symbol);

  // Dynamic icon URL (async resolved)
  const dynamicUrl = useResolvedIcon(symbol);

  // Reset error states when symbol changes
  useEffect(() => {
    setImgError(false);
    setFallbackError(false);
    setDynamicError(false);
  }, [symbol]);

  const imgStyle = { borderRadius: "50%", display: "block", objectFit: "cover" };

  // 1) Try static CoinGecko mapping
  if (url && !imgError) {
    return (
      <img
        src={url}
        alt={symbol}
        width={size}
        height={size}
        onError={() => setImgError(true)}
        style={imgStyle}
      />
    );
  }

  // 2) Try Trust Wallet fallback
  if (trustUrl && !fallbackError) {
    return (
      <img
        src={trustUrl}
        alt={symbol}
        width={size}
        height={size}
        onError={() => setFallbackError(true)}
        style={imgStyle}
      />
    );
  }

  // 3) Try dynamically resolved icon
  if (dynamicUrl && !dynamicError) {
    return (
      <img
        src={dynamicUrl}
        alt={symbol}
        width={size}
        height={size}
        onError={() => setDynamicError(true)}
        style={imgStyle}
      />
    );
  }

  // 4) Letter fallback
  return (
    <div style={{
      width: size,
      height: size,
      borderRadius: "50%",
      background: meta.bg,
      border: `1.5px solid ${meta.color}30`,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: size * 0.42,
      fontWeight: 600,
      color: meta.color,
      fontFamily: "'IBM Plex Mono', monospace",
      flexShrink: 0,
    }}>
      {meta.letter}
    </div>
  );
}
